<template>
  <div id="app">
    <link
      rel="stylesheet"
      type="text/css"
      href="https://fonts.googleapis.com/css?family=Roboto:300,400,700,700italic,400italic"/>
    <meta name="robots" content="noindex">
    <nav v-show="displayFrontend && $route.params.hashedId" id="nav">
      <img
        alt="Dyflexis logo"
        src="@/assets/logo.png"/>
      <router-link v-show="!showJustBilling" :to="'/projectteam/' + $route.params.hashedId">
        {{ $t("Project") }}
      </router-link>
      <router-link v-show="showHardwareShipping" :to="'/rex-o-matic/' + $route.params.hashedId">
        {{ $t("Hardware delivery") }}
      </router-link>
      <router-link v-show="externalPayment===false" :to="'/billing/' + $route.params.hashedId">
        {{ $t("Billing") }}
      </router-link>

      <span style="height: 4vh;"></span>

      <router-link v-show="!showJustBilling" :to="'/systemname/' + $route.params.hashedId">
        {{ $t("System") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/departments/' + $route.params.hashedId">
        {{ $t("Company structure") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/employee-settings/' + $route.params.hashedId">
        {{ $t("Employee Management") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/contracts/' + $route.params.hashedId">
        {{ $t("Contracts") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/overtime/' + $route.params.hashedId">
        {{ $t("Overtime") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/allowances/' + $route.params.hashedId">
        {{ $t("Allowances") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/leave/' + $route.params.hashedId">
        {{ $t("Leave") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/hour-types/' + $route.params.hashedId">
        {{ $t("Hourtypes") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/break-settings/' + $route.params.hashedId">
        {{ $t("Break rules") }}
      </router-link>
      <router-link v-show="!showJustBilling" :to="'/rounding-settings/' + $route.params.hashedId">
        {{ $t("Rounding rules") }}
      </router-link><br>

      <div v-show="!showJustBilling" >
        <a v-show="!showSignOnboarding" class="nav__sign nav__signDisabled"
           :title="$t('Confirming the system settings is available after the intake')">{{ $t("Sign") }}</a>
        <router-link v-show="showSignOnboarding" :to="'/sign/' + $route.params.hashedId" class="nav__sign">
          {{ $t("Sign") }}
        </router-link>

        <p id="consultantName" :title="$t('Your consultant can immediately see the data you have entered. Once these have been discussed, the consultant can open the option to sign and confirm the settings.')">
          {{ $t("Your Dyflexis consultant:") }}<br/>{{ consultantName }}
        </p>
      </div>

      <b-form-select v-model="locale" @change="changeLocale" id="selectLocale">
        <b-form-select-option value="null" disabled>Select language</b-form-select-option>
        <b-form-select-option value="en-GB">English</b-form-select-option>
        <b-form-select-option value="de-DE">Deutsch</b-form-select-option>
        <b-form-select-option value="nl-NL">Nederlands</b-form-select-option>
      </b-form-select>
    </nav>
    <main class="mainWindow">
      <router-view/>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
  props: ['b'],
  data() {
    return {
      displayFrontend: false,
      showHardwareShipping: false,
      showSignOnboarding: false,
      externalPayment: false,
      showJustBilling: false,
      consultantName: '',
      locale: null,
    };
  },
  beforeMount() {
    if (localStorage.getItem('latestRemote') == null) {
      return;
    }

    let latestRemote = localStorage.getItem('latestRemote');
    latestRemote = JSON.parse(latestRemote);
    if (latestRemote.consultantName) {
      this.consultantName = latestRemote.consultantName;
    }

    if (latestRemote.hardwareAmount > 0) {
      this.showHardwareShipping = true;
    }

    if (latestRemote.externalPayment === true) {
      this.externalPayment = true;
    }

    if (latestRemote.showJustBilling === true) {
      this.showJustBilling = true;
    }

    if (latestRemote.signReady === true) {
      this.showSignOnboarding = true;
    } else {
      this.reCheckSign();
    }

    localStorage.setItem('language', 'en-EN');
    if (latestRemote.accountLanguage === 'NL') {
      this.$i18n.locale = 'nl-NL';
      localStorage.setItem('language', 'nl-NL');
    }

    if (latestRemote.accountLanguage === 'DE') {
      this.$i18n.locale = 'de-DE';
      localStorage.setItem('language', 'de-DE');
    }

    this.displayFrontend = true;
  },
  methods: {
    reCheckSign() {
      setTimeout(function () {
        let latestRemote = localStorage.getItem('latestRemote');
        latestRemote = JSON.parse(latestRemote);

        if (latestRemote.signReady === true && this.showSignOnboarding !== true) {
          location.reload();
        }
      }, 2000);
    },
    changeLocale() {
      this.$i18n.locale = this.locale;
      localStorage.setItem('language', this.locale);
    }
  }
};
</script>

<style>
.nav__sign {
  font-style: italic;
  padding-top: 4.2vh;
}

.nav__signDisabled {
  cursor: not-allowed;
  padding-top: 4.2vh;
  opacity: 0.3;
}

.questions {
  width: 100%;
  height: 100%;
  padding: 15vh 5vw;
  overflow-y: scroll;
  overflow-x: hidden;
}

.saveHover {
  width: 100%;
  padding-bottom: 2vh;
  position: fixed;
  bottom: 0;
  background-color: white;
  z-index: 99;
  overflow-y: hidden;
  overflow-x: hidden;
}

.questions p {
  max-width: 40vw;
}

.questions__save {
  opacity: 0.3;
  cursor: wait;
  pointer-events: none;
}

.questions--slashNenter {
  white-space: pre-wrap;
}

.questions__header {
  padding-bottom: 0.8vh;
  padding-top: 2vh;
  font-weight: bold;
  font-size: 1.2rem;
  border-bottom: 1px solid #153658;
}

.question--margintop {
  margin-top: 7vh;
}

.questions__subheader {
  width: 40vw;
  margin-top: 2.5vh;
  color: #153658;
  font-size: 1rem;
  font-weight: normal;
}

.questions__inner {
  width: 40vw;
}

.departements__left {
  width: 40vw;
  display: inline-block;
}

.departments__right {
  width: 20vw;
  margin-left: 5vw;
  display: inline-block;
  vertical-align: top;
}

#questions-nameinput {
  display: inline-block;
  width: 14.5vw;
  margin-left: 0.5vw;
}

.questions-saluationinput {
  width: 10vw;
}

.list-group {
  width: 40vw;
}

.questions-dropdown {
  width: 40vw;
}

#questions-dropdownHalf {
  width: 20vw;
}

.question__paragraph-margin {
  margin-top: 2vh;
  margin-bottom: 2vh;
}

.question--marginTop {
  margin-top: 2vh;
}

.question--extraMarginTop {
  margin-top: 5vh;
}

h3 {
  margin: 40px 0 0;
}

ol {
  padding-left: 1rem;
}

ul {
  width: 40vw;
}

li ul {
  list-style-type: none;
  padding-left: 1rem;
}

.question__subdepartment {
  margin-left: 2em;
}

input[type="text"],
input[type="date"],
input[type="email"],
.custom-radio {
  width: 100%;
  max-width: 40vw;
}

.questions__textarea {
  width: 40vw !important;
  max-height: 25rem;
}

.questions--fullwidth {
  width: 100%;
}

.cursor__pointer {
  cursor: pointer;
}

.questions--savesuccess {
  width: 40vw;
  font-size: 1.3em;
  font-weight: 800;
  color: green;
  text-align: center;
  margin-top: 1vh;
}

.inputinline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.deliveryCity {
  display: inline-block;
  margin: 0;
  width: 32.5vw;
  margin-right: 0.5vw;
}

.deliveryStreet {
  display: inline-block;
  margin: 0;
  width: 25vw;
}

.deliveryStreetNumber {
  display: inline-block;
  margin: 0;
  width: 7vw;
  margin-left: 0.5vw;
}

.deliveryPostalCode {
  display: inline-block;
  margin: 0;
  width: 6.5vw;
}

#postal_code {
  width: 7vw;
}

.questions__halfInputWidth {
  display: inline-block;
  width: 19.75vw;
  margin: 0;
}

.questions__halfInputWidth input {
  width: 19.75vw;
}

.questions__halfInputWidthLeft {
  margin-right: 0.5vw;
}

.questions__inputerrordescription {
  display: block;
  color: #e20a0a;
}

.deliveryName input, .deliveryEmail input {
  width: 19.75vw;
}

#app {
  overflow-y: hidden;
  color: #2c3e50;
  font-family: Roboto, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  display: grid;
  grid-template-columns: 22vw auto;
  grid-template-areas: "nav main";
  align-items: stretch;
}

.mainWindow {
  grid-area: main;
  max-height: 100vh;
}

#nav {
  grid-area: nav;
  display: inline-grid;
  grid-template-rows: 20vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh 3.8vh;
  background-color: #f8f8f8;
  box-shadow: 3px 3px 6px #00000019;
  opacity: 1;
}

#nav img {
  display: block;
  width: 13vw;
  margin-top: 6vh;
  margin-right: auto;
  margin-bottom: 6vh;
  margin-left: auto;
  image-rendering: optimizeQuality;
}

#nav a {
  margin-left: 5.5vw;
  color: #153658;
  font-size: 1.25rem;
}

#nav a.router-link-exact-active,.bold {
  font-weight: bold;
}

a {
  color: #153658;
}

.checkbox,
button {
  margin-top: 2vh;
}

.infogray {
  width: 10vw;
  margin-top: 2vh;
  color: #8897a2;
  font-size: 1rem;
}

.breakItem p {
  margin-bottom: 0 !important;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}

.grayBackground {
  background-color: #f1f1f1;
}

.inputinline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  width: 40vw;
}

.submenu {
  margin-top: 7vh;
}

select,
input[type="number"],
input[type="time"],
.questions--smallinput {
  width: 100%;
  max-width: 40vw;
}

.max4vw {
  max-width: 4vw !important;
}

.max7vw {
  max-width: 7vw !important;
}

.max8vw {
  max-width: 8vw !important;
}

.max10vw {
  max-width: 10vw !important;
}

.width14vw {
  width: 14vw !important;
}

.inputHeight {
  height: calc(1.5em + 0.75rem);
}

.questions--inputmargin {
  margin-bottom: 1vh;
}

.questions--noinputmargin {
  margin-bottom: 0;
}

.questions--breakLength {
  margin-bottom: 2vh;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.questions--minutesBreak {
  display: inline-block !important;
  width: 3.5em !important;
}

.questions--minutesBreakName {
  display: inline-block !important;
  width: 12vw !important;
}

input[type="button"] {
  display: block;
  width: 40vw;
  margin-top: 2vh;
  padding: 15px 32px;
  color: white;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  background-color: #153658;
  border: none;
}

#saveStatus {
  color: green;
  opacity: 1;
  -webkit-transition: opacity 2s ease-in-out;
  -moz-transition: opacity 2s ease-in-out;
  -ms-transition: opacity 2s ease-in-out;
  -o-transition: opacity 2s ease-in-out;
}

#consultantName {
  position: absolute;
  top: 88vh;
  width: 15vw;
  margin-left: 3.5vw;
  text-align: center;
}

#selectLocale {
  position: absolute;
  top: 95vh;
  width: 12.5vw;
  margin-left: 4.75vw;
  text-align: center;
}

.btn-group > .btn {
  color: #152935;
  background-color: #dfe3e6;
  border: none;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #ffffff;
  background-color: #153658 !important;
}

.btn-outline-primary:hover {
  color: #ffffff;
  background-color: #153658 !important;
}

.hidden {
  display: none;
}

.wrongIban {
  border: 1px solid #e20a0a !important;
  background-color: #fde9e7 !important;
}

.questions__shifttimes p, .questions__shifttimes input, .inline  {
  display: inline-block !important;
}

.questions__teammember,.questions__subspace {
  margin-top: 3vh;
}

.questions__userroles {
  width: 10vw;
}

.questions__contracttype {
  width: 8vw;
}

th, td {
  padding-right: 1vw;
  line-height: initial;
}

tr .custom-control-label {
  vertical-align: text-top;
}

.questions__trDropdown {
  height: 5vh;
  vertical-align: middle;
}

.questions__devide {
  padding-top: 4vh;
  border-top: 1px solid #153658;
  margin-top: 4vh;
}

.questions__overtimeBetweenLines {
  font-size: 1rem;
  margin-bottom: 0.5vh;
  margin-top: 0.5vh;
  padding-bottom: 0;
}

.teammember__saluationinput {
  width: 10vw;
  position: relative;
  top: -1px;
}

#teammember__name {
  display: inline-block;
  width: 10vw;
  margin-bottom: 1vh;
  margin-left: 0.5vw;
}

#teammember__title {
  display: inline-block;
  width: 10vw;
  margin-left: 0.5vw;
}

#teammember__email {
  display: inline-block;
  width: 14vw;
  margin-left: 0.5vw;
}

#teammember__phone {
  display: inline-block;
  width: 10.5vw;
  margin-left: 0.5vw;
  float: right;
}

.teammember__contactlanguage {
  display: inline-block;
  width: 10vw;
  position: relative;
  top: -1px;
}

.teammember__marginleft {
  margin-left: 0.5vw;
}

.teammember__delete {
  height: calc(1.5em + 0.75rem + 2px);
  width: 10.5vw;
  padding: 0.375rem 0.75rem;
  margin-top: 0;
  float: right;
}

.workDayRuleName {
  display: inline-block !important;
  width: 29vw !important;
  margin-right: 0.5vw;
}

.workDayRule__delete {
  display: inline-block;
  height: calc(1.5em + 0.75rem + 2px);
  width: 10.5vw;
  padding: 0.375rem 0.75rem;
  margin-top: 0;
}

.teammember__contactSettings {
  display: inline-block;
}

.teammember__boolean {
  display: inline-block !important;
  margin-left: 0.5vw;
}

.teammember__addRow,
.department__addRow {
  margin-top: 1vh;
  margin-bottom: 1vh;
  width: 10vw;
}

.overtime__addRow {
  margin-top: -5vh;
  margin-bottom: 1vh;
}

.holidaycustom__addRow {
  width: 100%;
  margin-bottom: 1vh;
}

.question__overtimeName {
  width: 10vw;
}

.question__overtimeRate {
  width: 8vw;
}

.question__overtimeStart {
  width: 7vw;
}

.question__overtimeMedium {
  width: 5vw !important;
}

.question__overtimeSmall {
  width: 5vw;
}

.questions__overtime {
  margin-top: 5vh;
  padding-top: 5vh;
  border-style: solid;
  border-color: #153658;
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
}

.questions__rowMarginTop {
  margin-top: 5vh;
}

.question__deleteOvertime {
  vertical-align: top;
}

.questions__allowanceDay {
  display: grid;
  grid-template-columns: 4fr 2fr 2fr 2fr 2fr 3fr 3fr 2fr;
  grid-column-gap: 0.5rem;
  grid-template-rows: auto;
}

.questions__allowanceOvertime {
  display: grid;
  grid-template-columns: 3fr 1.5fr 2fr 3fr 2fr 3fr 2fr;
  grid-column-gap: 0.5rem;
  grid-template-rows: auto;
}

#questions__systemname {
  width: 7vw;
  opacity: .5;
  padding-top: 1em;
}

#questions__systemnameInput {
  width: 33vw;
}

.fit-content {
  width: fit-content !important;
}

.form-control.allowance__condition {
  grid-column-start: 1;
  grid-column-end: -1;
  margin-top: 1rem;
  margin-bottom: 3rem;
  max-width: 100%;
}

</style>
